import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Validation {
  code: string
  name: string
  description: string
  countries: string[]
  validation: string[]
}

export async function getValidations(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [`(countries is null or jsonb_exists(countries, :countryId))`]
  if (search) {
    where.push(
      `CONCAT(validations.name, validations.code, countries.name, validations.description) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          'group by validations.id',
          `ORDER BY (CASE WHEN validations.code ~ '^[0-9]+$' THEN CAST(validations.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, validations.code ${dataOrder[0]}`
        ])
      : (modifier = [
          'group by validations.id',
          `order by ${dataOrder[1]} ${dataOrder[0]}`
        ])
    : (modifier = [
        'group by validations.id',
        "ORDER BY (CASE WHEN validations.code ~ '^[0-9]+$' THEN CAST(validations.code AS numeric) ELSE NULL END), validations.code"
      ])

  // result
  const response: any = await getData({
    tables: ['pg_validations'],
    fields: [
      'validations.id',
      'validations.name',
      'validations.code',
      'validations.description',
      "coalesce(string_agg(distinct countries.name,','),'') as countries_name",
      'validations.is_inactive',
      'validations.is_deleted',
      'validations.updated_at'
    ],
    join: [
      'INNER JOIN LATERAL jsonb_array_elements_text(validations.countries) c(country) ON TRUE',
      'INNER JOIN countries ON countries.id = c.country::uuid'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getValidation(id: string): Promise<Validation> {
  const data = await getData<any>({
    tables: ['pg_validations'],
    fields: [
      'id',
      'name',
      'code',
      'description',
      'validation',
      'countries'
      //'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createValidation(data: Validation): Promise<boolean> {
  const response: any = await http.post('calculation/validations', {
    name: data.name,
    code: data.code,
    description: data.description,
    countries: data.countries,
    validation: data.validation
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateValidation(
  data: Validation,
  id: string
): Promise<boolean> {
  const response: any = await http.put('calculation/validations/' + id, {
    name: data.name,
    code: data.code,
    description: data.description,
    countries: data.countries,
    validation: data.validation
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateValidation(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(
    `calculation/validations/${id}/enable/`,
    {
      enable
    }
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
